/** 用户信息 */
export const user = [
  {
    name: 'getCurrentUserInfo', // 用户个人信息
    isMock: false,
  },
  {
    name: 'getUserInfo', // 个人中心-用户信息
    isMock: false,
  },
]
